import { render, staticRenderFns } from "./Prestation.vue?vue&type=template&id=d03cc7fe&scoped=true"
import script from "./Prestation.vue?vue&type=script&lang=js"
export * from "./Prestation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d03cc7fe",
  null
  
)

export default component.exports